import { ActionTypes } from './constants';
import * as Models from './models';

export const setCountryAbbreviations: Models.ActionCreator.SetCountryAbbreviations = countryAbbreviations => ({
  type: ActionTypes.SET_COUNTRY_ABBREVIATIONS,
  payload: {
    countryAbbreviations,
  },
});
